import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_BASE_URL }),
  reducerPath: "adminApi",
  tagTypes: [
    "User",
    "Sessions",
    "ParsedLogs",
    "Customers",
    "Transactions",
    "Geography",
    "Sales",
    "Admins",
    "Performance",
    "Dashboard",
    "Invoices",
    "CustomerGeography",
     "InvoiceGeography"
  ],
  endpoints: (build) => ({
    getUser: build.query({
      query: (id) => `general/user/${id}`,
      providesTags: ["User"],
    }),
    getSessions: build.query({
      query: () => "client/sessions",
      providesTags: ["Sessions"],
    }),
    getParsedLogs: build.query({
      query: () => "client/parsedlogs",
      providesTags: ["ParsedLogs"],
    }),
    getUsers: build.query({
      query: () => "client/users",
      providesTags: ["Users"],
    }),
    getCustomers: build.query({
      query: () => "client/customers",
      providesTags: ["Customers"],
    }),
    getTransactions: build.query({
      query: ({ page, pageSize, sort, search }) => ({
        url: "client/transactions",
        method: "GET",
        params: { page, pageSize, sort, search },
      }),
      providesTags: ["Transactions"],
    }),
    getGeography: build.query({
      query: (type = "master") => `client/geography?type=${type}`,
      providesTags: ["Geography"],
    }),
    getSales: build.query({
      query: () => "sales/sales",
      providesTags: ["Sales"],
    }),
    getAdmins: build.query({
      query: () => "management/admins",
      providesTags: ["Admins"],
    }),
    getUserPerformance: build.query({
      query: (id) => `management/performance/${id}`,
      providesTags: ["Performance"],
    }),
    
    getDashboard: build.query({
      query: () => "general/dashboard",
      providesTags: ["Dashboard"],
    }),
    getDailyInvoices: build.query({
      query: ({ year, month }) => ({
        url: '/api/dashboard/daily-stats',
        params: { year, month },
      }),
      providesTags: ['Dashboard'],
    }),
    createUser: build.mutation({
      query: (user) => ({
        url: "/api/auth/register",
        body: user,
        method: "POST",
      }),
    }),
    forgotPassword: build.mutation({
      query: (value) => ({
        url: "/api/auth/forgotPassword",
        body: value,
        method: "POST",
      }),
    }),
    resetPassword: build.mutation({
      query: (value) => ({
        url: "/api/auth/password-reset",
        body: value,
        method: "POST",
      }),
    }),
    ParsedLogs: build.mutation({
      query: (value) => ({
        url: "/api/auth/parsed-Logs",
        body: value,
        method: "POST",
      }),
    }),
    Sessions: build.mutation({
      query: (value) => ({
        url: "/api/auth/sessions",
        body: value,
        method: "POST",
      }),
    }),
    Admin: build.mutation({
      query: (email) => ({
        url: "/client/getadmin",
        body: email,
        method: "POST",
      }),
    }),
    getDashboardStats: build.query({
      query: (params = {}) => ({
        url: "/api/dashboard/stats",
        params,                    // Supports ?company=xxx&sourceUser=yyy etc.
      }),
      providesTags: ["DashboardStats"],
    }),
      getCustomerGeography: build.query({
  query: (body = {}) => ({
    url: "/api/customers/customer-geography",     // ← Corrected
    method: "POST",
    body,
  }),
  providesTags: ["CustomerGeography"],
}),

getInvoiceGeography: build.query({
  query: (body = {}) => ({
    url: "/api/customers/invoice-geography",      // ← Corrected
    method: "POST",
    body,
  }),
  providesTags: ["InvoiceGeography"],
}),

    // ── Invoices ──────────────────────────────────────────────────────────────

    // Paginated invoice cards (page, limit, status, search, date range)
    getInvoices: build.mutation({
      query: (body) => ({
        url: "/api/auth/invoice-stats",
        method: "POST",
        body,
      }),
    }),

    // Legacy date-range refetch (kept for backward compat)
    Invoices: build.mutation({
      query: (value) => ({
        url: "/api/auth/invoice-stats",
        method: "POST",
        body: value,
      }),
    }),

    // Summary stats — totalInvoices, totalInvoiced, totalDue, uniqueCustomers
    getInvoiceSummaryStats: build.mutation({
      query: (body) => ({
        url: "/api/auth/invoice-summary-stats",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetUserQuery,
  useGetSessionsQuery,
  useGetParsedLogsQuery,
  useGetUsersQuery,
  useGetCustomersQuery,
  useGetTransactionsQuery,
  useGetGeographyQuery,
  useGetSalesQuery,
  useGetAdminsQuery,
  useGetUserPerformanceQuery,
  useGetDashboardQuery,
  useGetDailyInvoicesQuery,
  useCreateUserMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useParsedLogsMutation,
  useSessionsMutation,
  useGetAdminQuery,
  useAdminMutation,
  useGetDashboardStatsQuery,
  useGetCustomerGeographyQuery,
  useGetInvoiceGeographyQuery,

  // Invoices
  useGetInvoicesMutation,
  useInvoicesMutation,
  useGetInvoiceSummaryStatsMutation,   // ← now correctly exported as a hook
} = api;
